import React, { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { LegendIconButton } from '../style/map_components';
import {
    Popover,
    Box,
    Typography,
    Stack,
    Collapse
} from '@mui/material';
import { Circle, ExpandMore } from '@mui/icons-material';

const MapRiverFloodLegendIcon = (props) => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [legendOpen, setLegendOpen] = useState(false);
    const [floodOpen, setFloodOpen] = useState(false);
    const [waterLevelOpen, setWaterLevelOpen] = useState(false);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (e) => {
        console.log('handleClose')
        setAnchorEl(null);
    };

    // アイコンのスタイル
    const iconStyle = { width: '21px', height: '21px' }

    const legendItems = [
        { color: '#9d49c5', label: '危険', threshold: '≧ 15' },
        { color: '#fd5367', label: '厳重警戒', threshold: '≧ 8' },
        { color: '#f28b41', label: '警戒', threshold: '≧ 5' },
        { color: '#faf500', label: '注意', threshold: '≧ 2' },
        { color: '#5c9fed', label: '通常', threshold: '≧ 0' },
    ];

    const telItems = [
        { color: '#9d49c5', label: '氾濫危険水位' },
        { color: '#fd5367', label: '避難判断水位' },
        { color: '#faf500', label: '氾濫注意水位' },
        { color: '#71c766', label: '水防団待機水位' },
        { color: '#63bbf2', label: '平常' },
        { color: '#808080', label: '欠測' },
    ];

    const ExpandableHeader = ({ label, expanded, toggle, sx = {} }) => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                mb: 0.5,
                ...sx,
            }}
            onClick={toggle}
        >
            <ExpandMore
                sx={{
                    transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
                    transition: 'transform 0.2s',
                    fontSize: 16,
                    mr: 0.5,
                }}
            />
            <Typography sx={{ fontSize: '0.75rem' }}>{label}</Typography>
        </Box>
    );

    return (
        <>
            <LegendIconButton
                onClick={handleClick}>
                <InfoIcon sx={iconStyle} />
            </LegendIconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ p: 1, maxHeight: 300, overflowY: 'auto' }}>
                    {/* タイトル部：クリックで開閉 */}
                    <ExpandableHeader
                        label="凡例"
                        expanded={legendOpen}
                        toggle={() => setLegendOpen(!legendOpen)}
                    />
                    <Collapse in={legendOpen}>
                        <Box sx={{ pl: 2 }}>
                            {/* サブセクション1 */}
                            <ExpandableHeader
                                label="避難推奨レベル（河川）"
                                expanded={floodOpen}
                                toggle={() => setFloodOpen(!floodOpen)}
                                sx={{ mb: 0.25 }}
                            />
                            <Collapse in={floodOpen}>
                                <Stack direction="column" spacing={0.5} pl={1}>
                                    {legendItems.map((item, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Circle sx={{ color: item.color, fontSize: "10px" }} />
                                            <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 60 }}>{item.label}</Typography>
                                            <Typography sx={{ fontSize: "10px", pl: 1, ml: '30px' }}>{item.threshold}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Collapse>
                        </Box>
                        <Box sx={{ pt: 1, pl: 2 }}>
                            {/* サブセクション2 */}
                            <ExpandableHeader
                                label="現在の水位"
                                expanded={waterLevelOpen}
                                toggle={() => setWaterLevelOpen(!waterLevelOpen)}
                                sx={{ mb: 0.25 }}
                            />
                            <Collapse in={waterLevelOpen}>
                                <Stack direction="column" spacing={0.5} pl={1}>
                                    {telItems.map((item, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Circle sx={{ color: item.color, fontSize: "10px" }} />
                                            <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 70 }}>{item.label}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Collapse>
                        </Box>
                    </Collapse>
                </Box>
            </Popover>
        </>
    );
};
export default MapRiverFloodLegendIcon;